import * as React from 'react'

import { Box, BoxList, Spinner, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import StatusItem, {
  StatusStruct,
} from 'modules/documents/components/DocumentPreview/Content/StatusItem'
import SignatureStatusTag from 'modules/documents/components/Documents/List/Item/SignatureStatusTag'
import { Document } from 'modules/documents/hooks/documents/useGetDocuments'
import type {
  EsignatureRequest,
  Signee,
} from 'modules/esignatures/hooks/requests/useGetEsignatureRequests'

interface Props {
  document: Document
  loading: boolean
  additionalSignees: EsignatureRequest[]
}

const SignatureRequests = ({ document, loading, additionalSignees }: Props) => {
  const employee = document.employee
  const toStatusStruct = (signee: Signee): StatusStruct => {
    return {
      signerFullName: signee.fullName,
      ...(signee.avatar && { signerAvatar: signee.avatar }),
      statusDescription: i18n.t('documents.modal.fillable.waiting_for', {
        employee: employee && employee.fullName,
      }),
    }
  }

  if (loading) {
    return (
      <Box alignItems="center">
        <Spinner />
      </Box>
    )
  }

  return (
    <>
      {additionalSignees.length > 0 && (
        <Box gap="s8">
          <Text size="100" color="grey800">
            {i18n.t('documents.modal.fillable.additional_signers')}
          </Text>
          <BoxList>
            {additionalSignees.map((request) => {
              return (
                <StatusItem
                  key={request.id}
                  status={toStatusStruct(request.signee)}
                  statusBox={<SignatureStatusTag status={'pending'} />}
                />
              )
            })}
          </BoxList>
        </Box>
      )}
    </>
  )
}

export default SignatureRequests
